import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { PdfViewerModule } from 'ng2-pdf-viewer';

import { ImgViewModule } from '../img-view/img-view.component';
import { InputErrorModule } from '../input-error/input-error.module';
import { SelectedDocComponent } from './selected-doc/selected-doc.component';
import { SelectedDocsComponent } from './selected-docs.component';

@NgModule({
  declarations: [SelectedDocsComponent, SelectedDocComponent],
  imports: [
    CommonModule,
    InputErrorModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ImgViewModule,
    PdfViewerModule,
  ],
  exports: [SelectedDocsComponent, SelectedDocComponent],
})
export class SelectedDocsModule {}
